﻿export enum ApplicationRole {
    admin = "urn:am:taxand:role:admin",
    contributor = "urn:am:taxand:role:contributor",
    reader = "urn:am:taxand:role:reader",
    developer = "urn:am:taxand:role:developer",
}
